// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Akcije_wrapper__N6GLo {
  padding: 70px 100px;
}

.Akcije_backimg__eWP9H {
  height: 24px;
  width: 24px;
}

.Akcije_back__Mqa82 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 24px;
  padding-bottom: 30px;
}

.Akcije_backtext__2QYF- {
  font-family: "Open Sans";
  font-weight: 700;
  margin: auto 5px;
  padding-bottom: 2px;
  color: #9fa7b2;
  width: 150px;
}

.Akcije_link__U7H9Q {
  text-decoration: none;
}

.Akcije_backtext__2QYF-:hover,
.Akcije_backimg__eWP9H:hover {
  cursor: pointer;
}

.Akcije_h1__dhnq3 {
  padding-bottom: 40px;
}

.Akcije_container__JHi29,
.Akcije_containerNovosti__ZCQfb {
  display: flex;
  padding-left: 100px;
  margin-bottom: 100px;
}

.Akcije_left__eLk3l,
.Akcije_leftNovosti__IqEVc {
  width: 50%;
}

.Akcije_imgContainer__hsqao,
.Akcije_imgContainerNovosti__B3Udh {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  padding-top: 50px;
}

.Akcije_img__sF5HA,
.Akcije_imgNovosti__4x9wT {
  height: 250px;
}

.Akcije_p__ulnf9,
.Akcije_h2__46vkL,
.Akcije_h3__Q2wkW {
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 16px;
  color: #747474;
}

.Akcije_h2__46vkL {
  padding-bottom: 25px;
}

.Akcije_h3__Q2wkW {
  padding-top: 15px;
}

/*Novosti media*/

@media screen and (max-width: 1200px) {
  .Akcije_containerNovosti__ZCQfb {
    gap: 50px;
  }
}

@media screen and (max-width: 1100px) {
  .Akcije_containerNovosti__ZCQfb {
    padding-left: 0px;
    flex-direction: column;
    gap: 0px;
  }
  .Akcije_leftNovosti__IqEVc {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .Akcije_imgNovosti__4x9wT {
    height: 250px;
  }
  .Akcije_leftNovosti__IqEVc,
  .Akcije_imgContainerNovosti__B3Udh {
    width: 80%;
    padding-left: 10%;
  }
  .Akcije_text__4fQOX {
    width: -moz-fit-content;
    width: fit-content;
  }
}

@media screen and (max-width: 750px) {
  .Akcije_imgNovosti__4x9wT {
    height: 200px;
  }
}

/*Akcije media*/

@media screen and (max-width: 1000px) {
  .Akcije_container__JHi29 {
    flex-direction: column;
    padding-left: 0px;
  }
  .Akcije_left__eLk3l {
    display: flex;
    justify-content: center;
  }

  .Akcije_img__sF5HA {
    height: 350px;
  }
  .Akcije_left__eLk3l,
  .Akcije_imgContainer__hsqao {
    width: 100%;
  }
  .Akcije_text__4fQOX {
    width: -moz-fit-content;
    width: fit-content;
  }
}

@media screen and (max-width: 600px) {
  .Akcije_img__sF5HA {
    height: 280px;
  }
  .Akcije_wrapper__N6GLo {
    padding: 50px 30px 0px;
  }
}
@media screen and (max-width: 450px) {
  .Akcije_img__sF5HA {
    height: 220px;
  }
}
@media screen and (max-width: 400px) {
  .Akcije_img__sF5HA {
    height: 190px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Akcije/Akcije.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;;AAEhB;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;EACA;;IAEE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,eAAe;;AAEf;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;EACA;;IAEE,WAAW;EACb;EACA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".wrapper {\n  padding: 70px 100px;\n}\n\n.backimg {\n  height: 24px;\n  width: 24px;\n}\n\n.back {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 24px;\n  padding-bottom: 30px;\n}\n\n.backtext {\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  margin: auto 5px;\n  padding-bottom: 2px;\n  color: #9fa7b2;\n  width: 150px;\n}\n\n.link {\n  text-decoration: none;\n}\n\n.backtext:hover,\n.backimg:hover {\n  cursor: pointer;\n}\n\n.h1 {\n  padding-bottom: 40px;\n}\n\n.container,\n.containerNovosti {\n  display: flex;\n  padding-left: 100px;\n  margin-bottom: 100px;\n}\n\n.left,\n.leftNovosti {\n  width: 50%;\n}\n\n.imgContainer,\n.imgContainerNovosti {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50%;\n  padding-top: 50px;\n}\n\n.img,\n.imgNovosti {\n  height: 250px;\n}\n\n.p,\n.h2,\n.h3 {\n  font-family: \"Open Sans\";\n  font-weight: 400;\n  font-size: 16px;\n  color: #747474;\n}\n\n.h2 {\n  padding-bottom: 25px;\n}\n\n.h3 {\n  padding-top: 15px;\n}\n\n/*Novosti media*/\n\n@media screen and (max-width: 1200px) {\n  .containerNovosti {\n    gap: 50px;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .containerNovosti {\n    padding-left: 0px;\n    flex-direction: column;\n    gap: 0px;\n  }\n  .leftNovosti {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .imgNovosti {\n    height: 250px;\n  }\n  .leftNovosti,\n  .imgContainerNovosti {\n    width: 80%;\n    padding-left: 10%;\n  }\n  .text {\n    width: fit-content;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .imgNovosti {\n    height: 200px;\n  }\n}\n\n/*Akcije media*/\n\n@media screen and (max-width: 1000px) {\n  .container {\n    flex-direction: column;\n    padding-left: 0px;\n  }\n  .left {\n    display: flex;\n    justify-content: center;\n  }\n\n  .img {\n    height: 350px;\n  }\n  .left,\n  .imgContainer {\n    width: 100%;\n  }\n  .text {\n    width: fit-content;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .img {\n    height: 280px;\n  }\n  .wrapper {\n    padding: 50px 30px 0px;\n  }\n}\n@media screen and (max-width: 450px) {\n  .img {\n    height: 220px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .img {\n    height: 190px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Akcije_wrapper__N6GLo`,
	"backimg": `Akcije_backimg__eWP9H`,
	"back": `Akcije_back__Mqa82`,
	"backtext": `Akcije_backtext__2QYF-`,
	"link": `Akcije_link__U7H9Q`,
	"h1": `Akcije_h1__dhnq3`,
	"container": `Akcije_container__JHi29`,
	"containerNovosti": `Akcije_containerNovosti__ZCQfb`,
	"left": `Akcije_left__eLk3l`,
	"leftNovosti": `Akcije_leftNovosti__IqEVc`,
	"imgContainer": `Akcije_imgContainer__hsqao`,
	"imgContainerNovosti": `Akcije_imgContainerNovosti__B3Udh`,
	"img": `Akcije_img__sF5HA`,
	"imgNovosti": `Akcije_imgNovosti__4x9wT`,
	"p": `Akcije_p__ulnf9`,
	"h2": `Akcije_h2__46vkL`,
	"h3": `Akcije_h3__Q2wkW`,
	"text": `Akcije_text__4fQOX`
};
export default ___CSS_LOADER_EXPORT___;
